String.prototype.format = function () {
    let args = arguments;
    return this.replace(/\{(\d+)\}/g, function (m, i) {
        return args[i];
    });
};

Date.prototype.format = function (fmt) {
    let o = {
        'M+': this.getMonth() + 1,
        'd+': this.getDate(),
        'h+': this.getHours(),
        'm+': this.getMinutes(),
        's+': this.getSeconds(),
        'q+': Math.floor((this.getMonth() + 3) / 3),
        'S': this.getMilliseconds()
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
        }
    }
    return fmt;
};

export default {
    title: '速电通',
    clientVersion: '1.0.0',
    baseUrl: {
        dev: 'https://gateway.chargetong.cn/',
        // dev: 'http://192.168.0.66:9000/',
        pro: 'https://gateway.chargetong.cn/'
    },
    mapKey: 'db36da9e7f8c463b273ec48bd6d6df6c',
    successCode: '000000',
    pageSize: 20
}